import { EnumService } from "../shared/EnumService";

export class PerfilUsuarioEnumService extends EnumService{

  constructor(){
    super('enumPerfilUsuario');
  }

}